import amazon from '@/assets/platforms/amazon.png';
import lojaintegrada from '@/assets/platforms/lojaintegrada.png';
import mercadolivre from '@/assets/platforms/mercadolivre.png';
import shein from '@/assets/platforms/shein.png';
import shopee from '@/assets/platforms/shopee.png';
import tiktokshop from '@/assets/platforms/tiktokshop.png';
import tiny from '@/assets/platforms/tiny.png';
import tray from '@/assets/platforms/tray.png';

/**
 * Ícone oficial de cada plataforma, pela chave do conector. Só identifica a integração na tela —
 * origem e data de cada arquivo em `src/assets/platforms/README.md`. Plataforma sem ícone aqui
 * (o canal fictício, uma nova) cai no ícone genérico da categoria.
 */
export const PLATFORM_LOGOS: Record<string, string> = {
  mercadolivre,
  shopee,
  tiktokshop,
  amazon,
  shein,
  tray,
  lojaintegrada,
  tiny,
};
